<template>
    <div :class="field.Class" class="Field__Component">
        <div><slot>{{value}}</slot></div>
    </div>
</template>

<script>
export default {
    name: 'FieldStandard',
    props: ['value', 'field'],
};
</script>

<style scoped>

</style>
